import React from "react";
import PanelHead from "../../UI/Panel/PanelHead";
import PanelBody from "../../UI/Panel/PanelBody";
import { TransactionTable } from "../../UI/Transaction/TransactionTable";

const Transactions = () => {
  return (
    <div>
      <PanelHead title="Transaction" />
      <PanelBody content={<TransactionTable />} />
    </div>
  );
};

export default React.memo(Transactions);
